/* global axios */
import ApiClient from './ApiClient';

class GgCustomersAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  lookup(contactId, criteria, { signal }) {
    return axios.post(`${this.url}/${contactId}/gg_customers`, criteria, {
      signal,
    });
  }

  link(contactId, customerId, { signal }) {
    return axios.put(
      `${this.url}/${contactId}/gg_customer`,
      { customer_id: customerId },
      { signal }
    );
  }
}

export default new GgCustomersAPI();
